import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { RappService } from 'src/app/services/rapp-services.service';
import { CurrentMapCodePath, DnvLatLng, DnvMapInfo, ProblemMenuSelection, SearchItem, SearchItemType, SearchLocation, SnowLayer, UniqueValueInfo } from 'src/app/store/application';
import { isMobile } from 'src/assets/isMobileChecker';

import * as $ from "jquery";

declare var L: any;

@Component({
  selector: 'app-location-selection',
  templateUrl: './location-selection.component.html',
  styleUrls: [
    './location-selection.component.scss', './leaflet.css', './leaflet.draw.css'
  ]
})
export class LocationSelectionComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() selectedLatLng: DnvLatLng | null;
  @Input() problemLocation: string;
  @Input() selectedProblemMenuItem: ProblemMenuSelection | null;
  @Input() isErrorPresentOnPage: boolean;
  @Output() selectedCoordinates = new EventEmitter<DnvLatLng>();
  @Output() selectedLocationNameOrigin = new EventEmitter<string>();
  @Output() selectedLocationName = new EventEmitter<string>();

  searchFieldText = '';
  selectedCurrentFieldText: string = "";

  map: any;
  marker: any;
  doPanToCurrentLocation: boolean = false;
  currentLocationMarker: any;

  previousZoomLevel: number = 0;
  prevMapCenter: any;
  markerPixelPoint: any;

  itemsMap: SearchItem[] = [];
  itemLoadInterval: any;
  timer: any;

  selectedLocation: SearchItem | null;

  canUseUpDownArrows: boolean = true;
  currentArrowKeySelectedNode: number = 0;

  mapInfo: DnvMapInfo = {
    mapSizeInPixel: "",
    mapBounds: {
      northWestBound: { lat: 49.67, lng: -123.55 },
      southEastBound: { lat: 48.96, lng: -122.6 }
    },
    latLng: {
      lat: 0,
      lng: 0
    }
  }

  isLoadedLocationMapPan: boolean = false;
  isLoadedLocationMarkerPan: boolean = false;

  currentMapCodePath: CurrentMapCodePath = CurrentMapCodePath.MovingMarker;

  shouldRunLoadLocate = false;
  skipInitialLoadLocate = false;

  isSearchResultMove: boolean = false;
  isLocateClicked: boolean = false;
  isMobile = isMobile;
  snowLayer: SnowLayer;
  snowLegendInfo: UniqueValueInfo[];

  readonly locationType: string[] = [
    'DNV Parks', 'Building', 'Parcels', 'Intersection Buffer', 'Street Centerline Buffer', 'DNV Boundary', 'MetroVan Boundary'
  ];

  constructor(private rappService: RappService) { }

  ngOnInit(): void {
    if (this.isMobile.any()) {
      this.currentMapCodePath = CurrentMapCodePath.Untouched;
    }

    if (this.problemLocation) {
      this.searchFieldText = this.problemLocation;
    }

    document.getElementById("locationSearchField")?.addEventListener('input', () => {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(this.performSearch.bind(this), 250);
    });

    document.addEventListener('keydown', this.handleKeyPress.bind(this));
    document.addEventListener('click', this.handleClickPress.bind(this));
  }

  ngOnChanges() {
    if (this.isErrorPresentOnPage) {
      document.getElementsByClassName("locationSearchInfo")[0].scrollIntoView({ behavior: 'smooth' });
    }
  }

  ngAfterViewInit(): void {
    this.buildDnvMap();
    this.zoomIfSelectedLatLng();

    if (this.currentMapCodePath !== CurrentMapCodePath.Untouched) {
      document.getElementsByClassName('leaflet-control-locate')[0].children[0].addEventListener('click', this.handleClickPress.bind(this));
    }
  }

  getSelectedMenuName() {
    if (this.selectedProblemMenuItem?.MenuTwo) {
      return `${this.selectedProblemMenuItem.MenuOne} > ${this.selectedProblemMenuItem.MenuTwo}`;
    }

    return this.selectedProblemMenuItem?.MenuOne;
  }

  handleErrorTextDisplay(locationError: string) {
    let errorMsg = '';

    if (locationError.includes("Out of Boundary")) {
      errorMsg = 'This location is outside the District of North Vancouver.'
    }

    if (locationError.includes("Squamish Nation")) {
      // errorMsg = 'This service is provided by Squamish Nation. Please <a href="https://www.squamish.net/contact-us/" target="_blank">contact them for help</a>.';
      errorMsg = 'This location is outside the District of North Vancouver.'
    }

    if (locationError.includes("Tsleil Waututh Nation")) {
      // errorMsg = 'This service is provided by Tsleil-Waututh Nation. Please <a href="https://twnation.ca/contact-us/" target="_blank">contact them for help</a>.';
      errorMsg = 'This location is outside the District of North Vancouver.'
    }

    (document.getElementById("searchErrorDisplay") as any).innerHTML = errorMsg;
  }

  handleTextUpdate() {
    if (this.selectedCurrentFieldText) {
      if (this.searchFieldText.toLowerCase().includes(this.selectedCurrentFieldText.toLowerCase()) &&
        this.searchFieldText.toLowerCase() !== this.selectedCurrentFieldText.toLowerCase()) {

        this.selectedLocationName.emit(this.searchFieldText);
      }
    }
  }

  handleKeyPress(event: any) {
    let locationItemsLength = $(".item").length;
    switch (event.key) {
      case "Escape":
        this.clearSelectedItemsMap();
        break;

      case "ArrowDown":
        if (locationItemsLength && this.canUseUpDownArrows) {
          if (this.currentArrowKeySelectedNode < locationItemsLength) {

            // assign the class to the next element
            $(".item")[this.currentArrowKeySelectedNode].classList.add("hover")

            // remove the class from the currently selected element
            if (this.currentArrowKeySelectedNode > 0) {
              $(".item")[this.currentArrowKeySelectedNode - 1].classList.remove("hover")
            }

            this.currentArrowKeySelectedNode++;
          }
        }
        break;

      case "ArrowUp":
        if (locationItemsLength && this.canUseUpDownArrows) {
          if (this.currentArrowKeySelectedNode > 0) {
            this.currentArrowKeySelectedNode--;

            // remove the class from the currently selected element
            $(".item")[this.currentArrowKeySelectedNode].classList.remove("hover");

            if (this.currentArrowKeySelectedNode > 0) {
              // assign the class to the previous one
              $(".item")[this.currentArrowKeySelectedNode - 1].classList.add("hover")
            }
          }
        }
        break;

      case "Enter":
        if (locationItemsLength && this.currentArrowKeySelectedNode > 0 && this.canUseUpDownArrows) {
          $(".item")[this.currentArrowKeySelectedNode - 1].click();
        }
        break;

      default:
    }
  }

  handleClickPress(event: any) {
    if (event.target.parentNode?.className !== "inputAutoComplete") {
      this.clearSelectedItemsMap();
    }

    // handle clicking leaflet-locate
    if (event.target.className === 'fa-crosshairs fa' || event.target.className === 'fa-spinner fa-spin fa') {
      this.isLocateClicked = true;
    }
  }

  clearSelectedItemsMap() {
    this.itemsMap = [];
    this.canUseUpDownArrows = true;
    this.currentArrowKeySelectedNode = 0;
  }

  buildDnvMap() {
    const northWestBound = { lat: 49.67, lng: -123.55 };
    const southEastBound = { lat: 48.96, lng: -122.6 };
    const bounds = L.latLngBounds(northWestBound, southEastBound);
    const centerPoint = { lat: 49.33801, lng: -123.04363 };
    const crs = new L.Proj.CRS('EPSG:26910', '+proj=utm +zone=10 +ellps=GRS80 +datum=NAD83 +units=m +no_defs', {
      origin: [474584, 5480125],
      resolutions: [
        21.16670900008467, 10.583354500042335, 5.291677250021167, 2.6458386250105836, 1.3229193125052918,
        0.6614596562526459, 0.26458386250105836, 0.13229193125052918, 0.06614596562526459
      ]
    });

    this.map = L.map('map', {
      crs: crs,
      zoomControl: false,
      keyboard: true,
      minZoom: 0,
      maxZoom: 8,
      maxBounds: bounds,
      tap: true,
      gestureHandling: true,
      gestureHandlingOptions: {
        text: {
          touch: "Use two fingers to move the map",
          scroll: "Use ctrl + scroll to zoom the map",
          scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        duration: 2000
      }
    }).setView(centerPoint, 0);

    L.esri.tiledMapLayer({
      url: 'https://geoweb.dnv.org/arcgis/rest/services/Basemap_Building/MapServer',
      minZoom: 0,
      maxZoom: 8,
      opacity: 1
    }).addTo(this.map);

    if(this.getSelectedMenuName() === 'Streets and sidewalks > Icy or snowy street') {
      L.esri.dynamicMapLayer({
        url: 'https://www.geoweb.dnv.org/arcgis/rest/services/Layers_Webtech_SnowRemovalRoute/MapServer',
        opacity: 1,
        f: 'image'
      }).addTo(this.map);

      this.rappService.getSnowLegend().subscribe((layer) => { 
        this.snowLayer = layer;
        this.snowLegendInfo = this.snowLayer.drawingInfo.renderer.uniqueValueInfos;
      });
    }

    L.control.locate({
      position: 'bottomright',
      drawCircle: false,
      keepCurrentZoomLevel: true,
      initialZoomLevel: 3,
      flyTo: false,
      icon: 'fa fa-crosshairs',
      locateOptions: {
        enableHighAccuracy: true
      }
    }).addTo(this.map);

    L.control.zoom({
      position: 'bottomright'
    }).addTo(this.map);

    this.createLeafletMarker(this.map.getCenter());

    this.previousZoomLevel = this.map.getZoom();
    this.markerPixelPoint = this.map.latLngToContainerPoint(this.marker.getLatLng());

    if (this.currentMapCodePath === CurrentMapCodePath.Untouched || this.currentMapCodePath === CurrentMapCodePath.MovingMarker) {
      this.map.on('movestart', () => {

        if (!this.isLoadedLocationMapPan && !this.isLoadedLocationMarkerPan) {
          // send the method to invalidate the location right away
          this.selectedCoordinates.emit({ lat: 0, lng: 0 });
          this.prevMapCenter = this.map.getCenter();

          let locationSearchField = (document.getElementById("locationSearchField") as HTMLInputElement);
          locationSearchField.value = "";
        }
      });
    }

    this.map.on('moveend', (event: any) => {
      if (document.getElementById("map")) {

        this.mapInfo.mapSizeInPixel = `${$("#map")[0].clientWidth},${$("#map")[0].clientHeight}`;
        this.mapInfo.latLng = event.target.getCenter();
        this.mapInfo.mapBounds.northWestBound = this.map.getBounds().getNorthWest();
        this.mapInfo.mapBounds.southEastBound = this.map.getBounds().getSouthEast();

        this.prevMapCenter = event.target.getCenter();
        this.previousZoomLevel = this.map.getZoom();
        this.markerPixelPoint = this.map.latLngToContainerPoint(this.marker.getLatLng());

        // Since these markers can be positioned, for the initial load, set the latlng after the map has finished moving
        if (this.currentMapCodePath === CurrentMapCodePath.ClickPlacement || this.currentMapCodePath === CurrentMapCodePath.MovingMarker) {
          if (this.shouldRunLoadLocate && !this.skipInitialLoadLocate) {
            this.shouldRunLoadLocate = false;

            // a marker will always exist for the initial load
            if (!this.selectedLatLng || (this.selectedLatLng!.lat === 0 && this.selectedLatLng!.lng === 0)) {
              this.marker.setLatLng(this.prevMapCenter);
              this.performReverseSearch();
            }
          }

          if (this.skipInitialLoadLocate) {
            this.shouldRunLoadLocate = false;
          }
        }

        // handle the various different situations post map move
        switch (this.currentMapCodePath) {

          // if the move is because of a search or locate, set the placed marker at the suggested location
          case CurrentMapCodePath.ClickPlacement:
            if (this.isSearchResultMove || this.isLocateClicked) {

              // if the marker exists then move otherwise create one
              if (this.marker) {
                this.marker.setLatLng(this.prevMapCenter);
              } else {
                this.createLeafletMarker(this.prevMapCenter);
              }

              this.isSearchResultMove = false;
              this.isLocateClicked = false;

              if (this.isLocateClicked) {
                this.performReverseSearch();
              }
            }
            break;

          // if the move is because of a search or locate, shift the marker over to the center of the map, otherwise use the NEW marker location to perform a reverse search
          case CurrentMapCodePath.MovingMarker:
            if (this.isLocateClicked || this.isSearchResultMove) {
              this.mapInfo.latLng = this.prevMapCenter;
              this.marker.setLatLng(this.prevMapCenter);

              this.isSearchResultMove = false;
              this.isLocateClicked = false;
            } else {
              this.mapInfo.latLng = this.marker.getLatLng();
            }

            if (this.isLoadedLocationMapPan) {
              this.isLoadedLocationMapPan = false;
              this.isLoadedLocationMarkerPan = false;

            } else {
              this.performReverseSearch();
            }

            break;

          // Just run the reverse search based on the map center point
          case CurrentMapCodePath.Untouched:
            this.performReverseSearch();
            break;

          default:
            break;
        }
      }
    });

    // handle the extra functions that are required
    switch (this.currentMapCodePath) {

      // Handle the click event on the map to trigger the addition and removal of the marker
      case CurrentMapCodePath.ClickPlacement:
        this.map.on('click', (event: any) => {
          if (!this.marker) {

            // place the marker and run the search
            this.createLeafletMarker(event.latlng);
            this.map.setView(this.marker.getLatLng(), this.map.getZoom());
            this.mapInfo.latLng = event.latlng;
            this.performReverseSearch();

          } else {

            // remove the marker and clear the entry from the the top search bar
            this.map.removeLayer(this.marker);
            this.marker = null;
            this.selectedCoordinates.emit({ lat: 0, lng: 0 });
            let locationSearchField = (document.getElementById("locationSearchField") as HTMLInputElement);
            locationSearchField.value = "";
          }
        });
        break;

      // handle shifting the marker alongside the map when panning
      case CurrentMapCodePath.MovingMarker:
        this.map.on('move', (event: any) => {
          let zoomedMarkerCoordinates = this.map.containerPointToLatLng(this.markerPixelPoint);
          let newMarkerLat = zoomedMarkerCoordinates.lat;
          let newMarkerLng = zoomedMarkerCoordinates.lng;

          let newLatLng = {
            lat: newMarkerLat,
            lng: newMarkerLng
          };

          this.marker.setLatLng(newLatLng);
          this.prevMapCenter = event.target.getCenter();
        });
        break;

      // keep the marker pinned to the center
      case CurrentMapCodePath.Untouched:
        this.map.on('move', (event: any) => {
          this.marker.setLatLng(event.target.getCenter());
          this.prevMapCenter = event.target.getCenter();
        });
        break;

      default:
        break;
    };

    if (!this.selectedLatLng || (this.selectedLatLng!.lat === 0 && this.selectedLatLng!.lng === 0)) {
      this.shouldRunLoadLocate = true;
      this.map.locate({
        setView: true,
        maxZoom: 3,
        enableHighAccuracy: true
      });

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(() => this.skipInitialLoadLocate = false, () => this.skipInitialLoadLocate = true);
      }
    }
  }

  createLeafletMarker(latLng: DnvLatLng) {
    let svgMarker = L.divIcon({
      html: `
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
        <desc>Created with Fabric.js 1.7.22</desc>
        <defs></defs>
        <g transform="translate(128 128) scale(0.72 0.72)">
          <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)" >
            <path d="M 45 0 C 32.957 0 23.159 9.798 23.159 21.841 c 0 11.369 8.732 20.732 19.841 21.746 V 88 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 V 43.587 c 11.109 -1.014 19.841 -10.377 19.841 -21.746 C 66.841 9.798 57.043 0 45 0 z M 50.863 20.5 c -3.032 0 -5.5 -2.467 -5.5 -5.5 c 0 -3.033 2.467 -5.5 5.5 -5.5 c 3.032 0 5.5 2.467 5.5 5.5 C 56.364 18.033 53.896 20.5 50.863 20.5 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
          </g>
        </g>
      </svg>
      `,
      className: "markerIcon"
    });

    if (this.currentMapCodePath === CurrentMapCodePath.MovingMarker) {
      this.marker = L.marker(latLng, {
        // icon: svgMarker,
        draggable: 'true'
      }).addTo(this.map);

      // For the moving marker, on marker pan, prevent anyone from going to the next page as it can be an invalid address
      this.marker.on('dragstart', () => {
        this.selectedCoordinates.emit({ lat: 0, lng: 0 });

        // only clear the field as zooming in and out wont change where the marker is placed. Only panning or dragging will
        if (this.previousZoomLevel === this.map.getZoom()) {
          let locationSearchField = (document.getElementById("locationSearchField") as HTMLInputElement);
          locationSearchField.value = "";
        }
      });

      // handle the marker drag event to get the new location details
      this.marker.on('dragend', (event: any) => {
        this.markerPixelPoint = this.map.latLngToContainerPoint(this.marker.getLatLng());
        this.mapInfo.latLng = event.target.getLatLng();
        this.performReverseSearch();
      });

    } else {
      // this.marker = L.marker(latLng, { icon: svgMarker }).addTo(this.map);
      this.marker = L.marker(latLng).addTo(this.map);
    }
  }

  zoomIfSelectedLatLng() {
    if (!!this.selectedLatLng && this.selectedLatLng?.lat !== 0 && this.selectedLatLng.lng !== 0) {
      this.isLoadedLocationMapPan = true;
      this.map.setView(this.selectedLatLng, 5);

      // If the location was selected previously, set the new coordinates for the marker on the map
      if (this.currentMapCodePath === CurrentMapCodePath.ClickPlacement || this.currentMapCodePath === CurrentMapCodePath.MovingMarker) {
        this.isLoadedLocationMarkerPan = true;
        this.marker.setLatLng(this.selectedLatLng);
      }
    }
  }

  performSearch() {
    if (this.searchFieldText.length > 0) {
      this.rappService.doDnvAddressSearch(this.searchFieldText).subscribe((searchItems) => {
        this.rappService.doDnvGisAddressSearch(this.searchFieldText).subscribe((intersections) => {
          const intersectionsFiltered = intersections.filter((intersection, index, self) =>
            index === self.findIndex((cmpIntersection) =>
              cmpIntersection.name === intersection.name && cmpIntersection.type === intersection.type
            )
          );

          this.itemsMap = [...searchItems, ...intersectionsFiltered];
          this.itemLoadInterval = setInterval(() => {
            if ($(".item").length) {
              $(".inputAutocomplete")[0].addEventListener('mouseenter', () => {
                this.canUseUpDownArrows = false
                if (this.currentArrowKeySelectedNode > 0) {
                  $(".item")[this.currentArrowKeySelectedNode - 1].classList.remove("hover");
                  this.currentArrowKeySelectedNode = 0;
                }
              });

              $(".inputAutocomplete")[0].addEventListener('mouseleave', () => this.canUseUpDownArrows = true);
            }

            if (this.itemsMap.length === 0 || $(".item").length) {
              clearInterval(this.itemLoadInterval);
            }
          }, 100);

        });
      });
    } else {
      this.clearSelectedItemsMap();
    }
  }

  getLocationString(arr: SearchLocation[]): string {
    arr = arr.sort((a, b) => (a.location > b.location) ? 1 : ((b.location > a.location) ? -1 : 0));
    let returnString = "";

    for (let i = 0; i < arr.length; i++) {
      let location = arr[i].location;

      if (!returnString.includes(location)) {
        returnString += location + " & ";
      }
    }

    returnString = returnString.substring(0, returnString.length - 3);
    return returnString;
  }

  performReverseSearch() {
    this.rappService.getLocationFromCoordinates(this.mapInfo).subscribe((location) => {
      const inReserve = location.filter(r => r.locationType === 'Indian Reserve Boundaries')[0];
      if (inReserve) {
        if (inReserve.location.includes('5')) {
          this.selectedCoordinates.emit({ lat: 0, lng: 0 });
          this.handleErrorTextDisplay('Squamish Nation');
          this.selectedLocation = null;

          return;
        } else if (inReserve.location.includes('2') && this.selectedProblemMenuItem?.IsSNation) {
          this.selectedCoordinates.emit({ lat: 0, lng: 0 });
          this.handleErrorTextDisplay('Squamish Nation');
          this.selectedLocation = null;

          return;
        } else if (inReserve.location.includes('3') && this.selectedProblemMenuItem?.IsTWNation) {
          this.selectedCoordinates.emit({ lat: 0, lng: 0 });
          this.handleErrorTextDisplay('Tsleil Waututh Nation');
          this.selectedLocation = null;

          return;
        }
      }

      let searchLocationName = this.locationType
        .map(lt => location.find(sl => sl.locationType === lt))
        .find(x => x && x.location !== 'Null');

      let locationVal = this.selectedLocation ?
        this.selectedLocation.name :
        (searchLocationName ? searchLocationName.location : 'Unknown Location');

      let locationSearchField = (document.getElementById("locationSearchField") as HTMLInputElement);

      if (locationSearchField) {
        locationSearchField.value = locationVal;
        this.selectedCurrentFieldText = locationVal;
        this.selectedLocationNameOrigin.emit(locationVal);

        if (locationVal.includes("Out of Boundary")) {
          this.selectedCoordinates.emit({ lat: 0, lng: 0 });
        } else {
          this.selectedCoordinates.emit(this.mapInfo.latLng);
        }

        this.handleErrorTextDisplay(locationVal);
      };

      this.selectedLocation = null;
    });
  }

  handleItemClick(item: SearchItem) {
    (document.getElementById("locationSearchField") as HTMLInputElement).value = item.name;
    this.clearSelectedItemsMap();
    this.selectedLocation = item;
    this.selectedCurrentFieldText = item.name;

    this.rappService.getLocationCoordinates(item).subscribe((coordinate) => {
      let latLng: any[] = [];

      if (item.type === SearchItemType.StreetName) {
        latLng = [coordinate.features[0].geometry.coordinates[0][1], coordinate.features[0].geometry.coordinates[0][0]];
        this.mapInfo.latLng = { lat: coordinate.features[0].geometry.coordinates[0][1], lng: coordinate.features[0].geometry.coordinates[0][0] };
      } else {
        latLng = [coordinate.lat, coordinate.lng];
        this.mapInfo.latLng = { lat: coordinate.lat, lng: coordinate.lng };
      }

      //Check if address is within first nation land
      this.rappService.getLocationFromCoordinates(this.mapInfo).subscribe((location) => {
        this.isSearchResultMove = true;
        const inReserve = location.filter(r => r.locationType === 'Indian Reserve Boundaries')[0];
        if (inReserve) {
          if (inReserve.location.includes('5')) {
            this.selectedCoordinates.emit({ lat: 0, lng: 0 });
            this.handleErrorTextDisplay('Squamish Nation');
            this.selectedLocation = null;
            this.map.setView(latLng, 5);
            return;
          } else if (inReserve.location.includes('2') && this.selectedProblemMenuItem?.IsSNation) {
            this.selectedCoordinates.emit({ lat: 0, lng: 0 });
            this.handleErrorTextDisplay('Squamish Nation');
            this.selectedLocation = null;
            this.map.setView(latLng, 5);
            return;
          } else if (inReserve.location.includes('3') && this.selectedProblemMenuItem?.IsTWNation) {
            this.selectedCoordinates.emit({ lat: 0, lng: 0 });
            this.handleErrorTextDisplay('Tsleil Waututh Nation');
            this.selectedLocation = null;
            this.map.setView(latLng, 5);
            return;
          }
        }

        this.map.setView(latLng, 5);
        this.selectedCoordinates.emit({
          lat: latLng[0],
          lng: latLng[1]
        });

      });
    });
  }
}
